<script lang="ts">
	import { clickOutside, closeOnEscape } from '../events/events'
	import { dropdownOpen } from '../overlays/dropdownOpen'
	import DropdownContent from './DropdownContent.svelte'
	import { type Snippet } from 'svelte'

	interface Props {
		opened?: boolean
		closeOnClickOutside?: boolean
		closeOnClickInside?: boolean
		closeOnEscapeKey?: boolean
		portal?: boolean
		placeholder?: Snippet<[{ opened: boolean; onclick: () => void }]>
		children?: Snippet
		maxWidth?: number
	}

	let {
		opened = $bindable(false),
		closeOnEscapeKey = true,
		portal = false,
		placeholder,
		children,
		maxWidth = 240,
	}: Props = $props()

	let placeholderElement: HTMLDivElement = $state(null)

	function handleDropdownClose() {
		opened = false
		$dropdownOpen = false
	}

	function handleDropdownToggle() {
		opened = !opened
		$dropdownOpen = opened
	}

	function handleDropdownCloseOnEscape() {
		if (closeOnEscapeKey) {
			handleDropdownClose()
		}
	}

	$effect(() => {
		document.documentElement.classList.toggle('is-dropdown-open', opened)
	})
</script>

<div
	bind:this={placeholderElement}
	class="relative"
	onclickOutside={handleDropdownClose}
	oncloseOnEscape={handleDropdownCloseOnEscape}
	use:clickOutside
	use:closeOnEscape={{ dropdown: true }}
>
	{@render placeholder?.({ opened, onclick: handleDropdownToggle })}

	{#if opened}
		<DropdownContent {maxWidth} {placeholderElement} {portal}>
			{@render children?.()}
		</DropdownContent>
	{/if}
</div>

<style lang="postcss">
	@media not screen(lg) {
		:global(.is-dropdown-open .intercom-lightweight-app-launcher),
		:global(.is-dropdown-open .intercom-like-button) {
			display: none;
		}
	}
</style>
